var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8BusinessReport50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M40 45L8 45 8 3 30 3 40 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1f5fe",
    d: "M38.5 14L29 14 29 4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M24,20c-4.949,0-9,4.051-9,9s4.051,9,9,9c2.6,0,4.949-1.1,6.551-2.849L24,29V20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M33,29c0-4.949-4.051-9-9-9v9H33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M24,29l6.551,6.151C32.051,33.551,33,31.4,33,29H24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8BusinessReport50);
export default __webpack_public_path__ + "static/media/icons8-business-report-50.a397c048b4d935c45ffc5dfc8010d5f6.svg";
export { ForwardRef as ReactComponent };